import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import Home from '@/pages/Home'
import Game from '@/pages/Game'
import Login from '@/pages/Login'
import Profile from '@/pages/Profile'
import Leaderboard from '@/pages/Leaderboard'
import BurnDashboard from '@/pages/BurnDashboard'

export const routes = [
  { path: '/' },
  { path: '/login' },
  { path: '/game' },
  { path: '/profile' },
  { path: '/leaderboard' },
  { path: '/burn-dashboard' }
]

function App() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen bg-[#0a0e27] flex items-center justify-center">
        <div className="text-white text-xl">Loading...</div>
      </div>
    )
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={!user ? <Login /> : <Navigate to="/game" />} />
        <Route path="/game" element={<Game />} />
        <Route path="/profile" element={user ? <Profile /> : <Navigate to="/login" />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/burn-dashboard" element={<BurnDashboard />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
